import { useState, useEffect, useCallback } from 'react';

// ─── HASH ROUTE ───────────────────────────────────────────────────────────────
// Tiny hash-based tab routing for the caregiver SharedView: '#/kids' → 'kids'.
// Gives phone users working deep links and a back button without react-router.

function readHash(fallback) {
  const h = window.location.hash.replace(/^#\/?/, '');
  return h || fallback;
}

export default function useHashRoute(fallback) {
  const [route, setRoute] = useState(() => readHash(fallback));

  useEffect(() => {
    const onChange = () => setRoute(readHash(fallback));
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, [fallback]);

  const navigate = useCallback(next => {
    window.location.hash = `/${next}`;
  }, []);

  return [route, navigate];
}
